<a [href]="ctaHref" [ngClass]="getClasses()">
  <ng-content></ng-content>
</a>